<script>
    import {Swiper, SwiperSlide} from 'swiper/svelte';

    // Import Swiper styles
    import 'swiper/css';

    import "swiper/css/navigation"


    // import Swiper core and required modules
    import SwiperCore, {
        Navigation
    } from 'swiper';

    // install Swiper modules
    SwiperCore.use([Navigation]);
    let testBg = '/wp-content/themes/hungryjack/images/pancake-hub/carousel/tip-01.jpg;'

    let currentBackgroundIndex = 0;

    let backgrounds = [ "/wp-content/themes/hungryjack/images/static/images/pancake-hub/carousel/tip-01.jpg","/wp-content/themes/hungryjack/images/static/images/pancake-hub/carousel/tip-03.jpg"]

    let currentBackground = backgrounds[currentBackgroundIndex];
/*    easy: 1, 3
    fluffy: 2*/

    function onSlideChange(e) {

        let activeIndex = e.detail[0][0].activeIndex;
        if(activeIndex === 1 || activeIndex === 3) {
            currentBackground = backgrounds[0];
        } else {
            currentBackground = backgrounds[1];
        }


    }

function RefreshBg(index) {

            currentBackground = backgrounds[index]
}

</script>

<section class="tips-tricks" style="background-image: url({currentBackground});">

    <div class="inner">
        <div class="slider-container">
            <button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button" style="display: block;">Previous</button>
            <div class="slider slick-initialized slick-slider">
                <div aria-live="polite" class="slick-list draggable">
                    <div class="slick-track" role="listbox">

                        <Swiper
                                cssMode="{true}"
                                navigation="{{nextEl: '.slick-next',prevEl: '.slick-prev'}}"
                                pagination="{true}"
                                mousewheel="{true}"
                                speed="{0}"
                                loop="{true}"
                                keyboard="{true}"
                                on:activeIndexChange="{onSlideChange}"
                                class="mySwiper">
                            <SwiperSlide>
                                <div class="slick-slide">
                                    <div class="tip-content">
                                        <h2>
                                            Jack's Featured Tips <span>Easy Squeezy.</span>
                                        </h2>
                                        <p>Clean, empty, squeezable bottle + pancake batter = no-mess breakfast. You're
                                            welcome.</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div class="slick-slide ">
                                    <div class="tip-content">
                                        <h2>
                                            Jack's Featured Tips <span>Fluff Up Those Flapjacks.</span>
                                        </h2>
                                        <p>For light and fluffy pancakes, make sure not to overmix your batter. You
                                            should still see some small lumps.</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        </Swiper>

                    </div>
                </div>

            </div>
            <button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button" style="display: block;">Next</button>
        </div>
    </div>
</section>


